import { union } from 'lodash';

import { IFilterOptions, orderByMethod } from '../components/data-filter/DataFilterHelper';
import { ConformanceLevels } from '../consts/ConformanceLevels';
import { formatFilterOptionsForEvSelect } from '../helpers/FormatHelper';
import { FieldOptionName } from '../interfaces/Scan';

import {
	ADDITIONAL_FILTER_PARAMS,
	getScanFilterOptionsV2,
	getScanResultsFieldOptions
} from './scan/ScanService';

export const getScansFilterListOptions = async (
	baseScanId: string,
	comparableScanId: string,
	option: FieldOptionName,
	viewId: string = null
): Promise<string[]> => {
	const baseScanOptions = await getScanResultsFieldOptions(baseScanId, option, viewId);
	const compareScanOptions = await getScanResultsFieldOptions(comparableScanId, option, viewId);
	return orderByMethod(union(baseScanOptions, compareScanOptions), option);
};

export const getInitialFilterOptions = async (
	scanId: string,
	viewId: string = null,
	params?: ADDITIONAL_FILTER_PARAMS
): Promise<IFilterOptions> => {
	const filterOptionsFromServer = await getScanFilterOptionsV2(scanId, viewId, params);

	const response: IFilterOptions = {
		types: formatFilterOptionsForEvSelect(orderByMethod(filterOptionsFromServer.types)),
		severities: formatFilterOptionsForEvSelect(
			orderByMethod(filterOptionsFromServer.severities, FieldOptionName.SEVERITY)
		),
		tags: [
			...formatFilterOptionsForEvSelect(orderByMethod(filterOptionsFromServer.tags)),
			{
				value: ConformanceLevels.UNSPECIFIED,
				label: ConformanceLevels.UNSPECIFIED
			}
		]
	};
	if (filterOptionsFromServer?.components) {
		response.components = formatFilterOptionsForEvSelect(filterOptionsFromServer.components);
	}
	return response;
};
